import React, {Component} from 'react';

class ExpandableTextarea extends Component{

    autosize = () => {
        const el = this.textInput;
        setTimeout(() => {
            el.style.cssText = 'height:auto;';
            // for box-sizing other than "content-box" use:
            // el.style.cssText = '-moz-box-sizing:content-box';
            el.style.cssText = 'height:' + `${el.scrollHeight + (el.offsetHeight - el.clientHeight)}` + 'px';
            if(el.offsetHeight >= this.props.scrollHeight){
                el.style.cssText += 'overflow-y: auto;'
            }
        },0);
    };

    render(){
        return (
            <textarea
                onKeyDown={this.autosize}
                ref={input => this.textInput = input}
                name={this.props.name}
                rows={this.props.rows}
                value={this.props.value}
                className={this.props.className}
                onChange={this.props.onChange}
            />
        )
    }
}

export default ExpandableTextarea;